import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { promotionEndDate } from 'reactApp/appHelpers/featuresHelpers';

const segment = !IS_PAID_USER;

/** CLOUDWEB-20401 Поддержать охватную компанию */
export const marchPromo2026 = segment && promotionEndDate && getFeature('march-promo-2026');

interface IPromoConfig {
    promoBtnLink: string;
    tabMenuPromoBtnLink: string;
    discountBtnLink: string;
    termsLink: string;
    productId: string;
}

export const marchPromo2026Config: IPromoConfig = getFeature('march-promo-2026-cfg') || {
    promoBtnLink:
        'action=request-payment&productId=W1TB_1y_ogogoblako_force_trial&utm_source=landing_promo_quota&utm_medium=promo_button_1tb3m&utm_campaign=cloud_mkt_flight_coverage_campaign_0326&mt_link_id=pgmxu2',
    tabMenuPromoBtnLink:
        'action=request-payment&productId=W1TB_1y_ogogoblako_force_trial&utm_source=landing_promo_quota&utm_medium=promo_button_action&utm_campaign=cloud_mkt_flight_coverage_campaign_0326&mt_link_id=u484c9',
    discountBtnLink:
        'action=request-payment&productId=W1TB_1y_ogogoblako_force_trial&utm_source=landing_promo_quota&utm_medium=promo_button_action&utm_campaign=cloud_mkt_flight_coverage_campaign_0326&mt_link_id=u484c9',
    termsLink: 'https://vk.cc/cU8r4P',
    productId: 'W1TB_1y_ogogoblako_force_trial',
};

export const marchPromo2026AnalyticsName = 'cloud_mkt_flight_coverage_campaign_0326';

export const marchPromo2026SidebarButton = isFeature('march-promo-2026-sidebar-button');

export const marchPromo2026OverquotaButton = isFeature('march-promo-2026-overquota-button');

export const marchPromo2026Anon = isFeature('march-promo-2026-anon');
